<template>
  <div class="login-box">
    <h3 class="login-title">ログイン方法の選択</h3>
    <p class="login-tip">前回のログイン方法－{{ loginTypeName[loginType] }}</p>
    <button v-if="loginType === 'fb'" class="fb-login" @click="readyLogin('fb')"></button>
    <button v-if="loginType === 'tw'" class="twi-login" @click="readyLogin('tw')"></button>
    <button class="to-login" @click="readyLogin('to')">ゲストログイン</button>
  </div>
</template>

<script type="text/javascript">
import { mapGetters, mapActions } from "vuex";
import h5Sdk, { SAVE_LOGIN_TYPE_LOCALSTORAGE, ACCOUNT_TYPE } from "../mixins/h5Sdk.js";
import globalConfig from "../utiles/globalConfig";

export default {
  name: "loginPopup",
  mixins: [h5Sdk],
  data() {
    return {
      loginType: globalConfig.getLclStorageItem(SAVE_LOGIN_TYPE_LOCALSTORAGE),
      loginTypeName: {
        tw: "Twitter",
        fb: "Facebook",
        to: "",
        mg: "",
      },
    };
  },
  methods: {
    readyLogin(type) {
      this.readyDoLogin(type).then((res) => {
        if (parseInt(res.result, 10) === 1) {
          try {
            globalConfig.statistics("login_success", { login_type: type });
          } catch (e) {}
          globalConfig.setLclStorageItem(SAVE_LOGIN_TYPE_LOCALSTORAGE, ACCOUNT_TYPE[type]);
          if (type === ACCOUNT_TYPE.to) {
            window.dataLayer.push({
              event: "tourist_register",
            });
          }
        } else {
          alert(res.msg);
        }
      });
    },
    readyDoLogin(type) {
      try {
        globalConfig.statistics("login_type", {
          login_type: type,
        });
      } catch (e) {}
      switch (type) {
        case ACCOUNT_TYPE.fb:
          return this.readyFbLogin("login");
        case ACCOUNT_TYPE.tw:
          return this.readyTwiLogin("login");
        case ACCOUNT_TYPE.to:
          return this.readyTouristLogin();
        default:
          return this.readyTouristLogin();
      }
    },
  },
};
</script>
